
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPassed as ObiPassedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-passed.js';
 
 
 

 
 export const ObiPassed = createComponent({
   react: React,
   tagName: 'obi-passed',
   elementClass: ObiPassedElement,
   events: {
     
   }
  });
 
 